// import { DeviceTypesEnum } from "../../enums/DeviceTypesEnum";
import { eLynxObjectTypeEnum } from "../../enums/eLynxObjectType";
// import { RulesEngineRuleTypeEnum } from "../../enums/RulesEngineTypeEnum";

// export function makeObjectEquatableKey(
//     objectType?: eLynxObjectTypeEnum,
//     id?: number,
//     deviceType?: DeviceTypesEnum,
//     ruleType?: RulesEngineRuleTypeEnum
// ): string {
//     return objectType === eLynxObjectTypeEnum.Tank
//         ? `${objectType}:${id}:${typeof deviceType === "number" ? deviceType : ""}`

//         : objectType === eLynxObjectTypeEnum.RulesEngineRuleInstance
//             ? `${objectType}:${id}:${typeof ruleType === "number" ? ruleType : ""}`

//             : `${objectType}:${id}`;
// }

export function makeObjectEquatableKey(
    objectType?: eLynxObjectTypeEnum,
    id?: number
): string {
    return `${objectType}:${id}`;
}
